import { ref } from "vue";
import { defineStore } from "pinia";
import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

type RequestResetLinkPayload = {
  email: string;
  domain: string;
};

type SetNewPasswordPayload = {
  email: string;
  password: string;
  confirm_password: string;
  token: string;
};

export const usePasswordResetStore = defineStore("passwordReset", () => {
  const email = ref<string>("");

  const requestResetLink = async ({
    email: emailValue,
    domain,
  }: RequestResetLinkPayload) => {
    email.value = emailValue;

    return await $http.post(`${getApiClientUrl()}/v1/idp/password/forgot`, {
      domain,
      email: emailValue,
    });
  };

  const setNewPassword = async ({
    email: emailValue,
    password,
    confirm_password,
    token,
  }: SetNewPasswordPayload) => {
    email.value = emailValue;

    return await $http.post(`${getApiClientUrl()}/v1/idp/password/reset`, {
      email: emailValue,
      password,
      confirm_password,
      token,
    });
  };

  return {
    email,
    requestResetLink,
    setNewPassword,
  };
});
